import React from 'react';

interface Props {}

const SimpleFooter: React.FC<Props> = () => (
  <footer className="py-16 border-t">
    <div className="text-center text-slate-green-500">SidelineSwap</div>
  </footer>
);

export default SimpleFooter;
